<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-dialog
      :visible="showDialog"
      style="padding-top: 0"
      class="package-box"
      :before-close="onCloseDialog"
    >
      <div class="work-title">
        <h3 style="margin: 0">工单：{{ workId }}</h3>
      </div>
      <div class="header-box">拆包信息</div>
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="工单原运单号：">
          <el-input
            v-model="work.back_express_no"
            size="mini"
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品名称:">
          {{ work.goods_name }}
        </el-form-item>
        <el-form-item label="商品图片：">
          <div style="width: 50px; height: 50px">
            <img
              style="height: 100%; width: 100%"
              :src="work.main_img"
              @click="imgClick(work.middle_img)"
            />
          </div>
        </el-form-item>
        <el-form-item label="用户上传图片：" style="margin-top: 10px">
          <div style="width: 50px; height: 50px">
            <img
              v-viewer
              style="height: 100%; width: 100%"
              :src="work.picture"
            />
          </div>
        </el-form-item>

        <el-form-item label="颜色/尺码/数量：">
          <div>
            {{ work.co_val + "/" + work.si_val + "/" + work.goods_number }}
          </div>
        </el-form-item>
        <el-form-item label="问题类型:">
          <el-select v-model="model.id" size="small" @change="problemChange">
            <el-option :value="0" label="全部"></el-option>
            <el-option
              v-for="item in problem"
              :key="item.problem_id"
              :value="item.problem_id"
              :label="item.problem_name"
            ></el-option>
          </el-select>
          <el-select v-model="model.sub_id" size="small">
            <el-option :value="0" label="全部"></el-option>
            <el-option
              v-for="item in subPorblem"
              :key="item.problem_id"
              :value="item.problem_id"
              :label="item.problem_name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="待拆包件数：">-->
        <!--<div>{{work.num}}</div>-->
        <!--</el-form-item>-->
        <el-form-item label="登记类型：">
          <el-select
            v-if="blp_type.length > 0"
            v-model="registrationType"
            placeholder="请选择"
            size="mini"
          >
            <el-option label="正常" value="0"></el-option>
            <el-option
              v-for="item in blp_type"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
          <i
            class="el-icon-plus"
            style="
              margin-left: 10px;
              height: 40px;
              width: 40px;
              cursor: pointer;
            "
            @click="addBlp"
          />
          <el-table :data="registrationData" style="width: 80%">
            <el-table-column prop="blp_type_index" label="类型">
              <template slot-scope="scope">
                <div class="blp-text">
                  {{ getBlpText(scope.row.blp_type) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="数量" width="150">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.num"
                  :min="min"
                  :max="Number(work.num)"
                  size="mini"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="blp_note" label="备注" width="150">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.blp_note"
                  size="mini"
                  placeholder="请输入内容"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="blp-img-up" label="图片">
              <template slot-scope="scope">
                <div v-if="!scope.row.blp_img" @click="setIndex(scope.$index)">
                  <el-upload
                    class="“upload”"
                    :action="action"
                    :on-success="handleSuccess"
                    with-credentials
                  >
                    <i class="el-icon-picture" style="font-size: 20px" />
                  </el-upload>
                </div>
                <img
                  v-if="scope.row.blp_img"
                  v-viewer
                  :src="scope.row.blp_img"
                  class="avatar"
                  style="width: 30px; height: 30px"
                />
              </template>
            </el-table-column>
            <el-table-column label="删除">
              <template slot-scope="scope">
                <div class="blp-op">
                  <i
                    class="el-icon-delete"
                    style="margin-left: 10px; font-size: 20px"
                    @click="deleteItem(scope.$index)"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div>
        <div class="header-box">
          已拆商品<span style="font-size: 14px; color: red" />
        </div>
        <el-table :data="dbids" style="width: 80%; margin: 0 auto">
          <el-table-column prop="" label="类型">
            <template slot-scope="scope">
              <div class="blp-text">
                {{ getBlpText(scope.row.blp_type_value) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="打标id">
            <template slot-scope="scope">
              <div class="blp-text">{{ scope.row.dbid }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态">
            <template slot-scope="scope">
              <div class="blp-text">
                {{ scope.row.da_biao_record_status }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="备注">
            <template slot-scope="scope">
              <div class="blp-text">{{ scope.row.blp_note }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 收件人信息 -->
      <div>
        <div class="header-box">
          无实物拆包<span style="font-size: 14px; color: red" />
        </div>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="输入件数：">
            <el-input
              v-model="form.no_back_num"
              placeholder="输入件数"
              size="mini"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="拆包备注：">
            <el-input
              v-model="form.back_remark"
              type="textarea"
              placeholder="输入拆包备注"
              size="mini"
              style="width: 400px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitData">确 定</el-button>
      </span>
    </el-dialog>
    <preview-image
      v-if="showImg"
      :imgs="imgs"
      :show="showImg"
      @closeBox="closeImg"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../../components/PreviewImage.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "UnPackage",
  components: { PreviewImage },
  props: {
    workId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      model: {
        id: 0,
        sub_id: 0,
      },
      parent_porblem_id: "0",
      porblem_id: "0",
      subPorblem: [],
      showImg: false,
      dbids: [],
      min: 0,
      resData: {},
      province: [],
      city: [],
      district: [],
      url: "/erp/Claims/getUnPackageData",
      loading: false, // 加载动画是否显示
      work: {},
      form: {
        back_remark: "",
        no_back_num: "",
      },
      init: 0,
      registrationType: "",
      blp_type: [],
      showDialog: true,
      registrationData: [],
      index: "",
      websock: null,
      print_data: null,
      fullscreenLoading: false,
      problem: [],
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    closeImg() {
      this.showImg = false;
    },
    imgClick(imgs) {
      this.showImg = true;
      this.imgs = imgs;
    },
    // websocket相关
    initWebSocket() {
      // 初始化weosocket

      const ishttps = document.location.protocol === "https:";
      let wsuri;
      if (ishttps) {
        wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        wsuri = "ws://localhost:13528"; // ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror() {
      // 错误
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd === "print") {
        if (obj.status === "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "重新打印",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.websocketsend(this.print_data);
          });
        } else {
          this.$message.success("打标成功");
          this.onCloseDialog();
        }
      }
    },
    websocketsend(agentData) {
      // 数据发送
      this.websock.send(agentData);
    },
    websocketclose() {
      // 关闭
    },
    getBlpText(e) {
      let text = "";
      if (e === "0") {
        return "正常";
      }
      this.blp_type.forEach((v) => {
        if (e === v.key) {
          text = v.label;
        }
      });
      return text;
    },
    submitData() {
      this.loading = true;
      const arg = {
        work_id: this.workId,
        detail: this.registrationData,
        form: this.form,
        problem_id: this.model.sub_id,
        back_express_no: this.work.back_express_no,
      };
      this.fullscreenLoading = true;
      this.$http.post("/erp/claims/claimsCbDabiao", arg).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          return;
        }
        this.$message.success("拆包成功，开始打标");
        this.onCloseDialog(); /* 2018-12-20  */
        this.print_data = JSON.stringify(res.data.data.print_data);
        if (this.print_data) {
          this.websocketsend(JSON.stringify(res.data.data.print_data));
        }
      });
    },
    setIndex(i) {
      this.index = i;
    },
    addBlp() {
      if (
        this.registrationData
          .map((ele) => ele.blp_type)
          .includes(this.registrationType)
      ) {
        return;
      }
      this.registrationData.push({
        blp_type: this.registrationType,
        goods_no: this.work.goods_no,
        co_id: this.work.co_id,
        si_id: this.work.si_id,
        num: 0,
        to_where: this.registrationType === "0" ? 4 : 3,
        blp_note: "",
        blp_img: "",
      });
    },
    handleSuccess(e) {
      if (e.code !== 200) {
        this.$message.error("图片上传失败");
        return;
      }
      const img = e.data.origin_files[0];
      if (!img) {
        this.$message.error("图片上传失败");
        return;
      }
      this.$set(this.registrationData[this.index], "blp_img", img);
    },
    deleteItem(index) {
      this.registrationData.splice(index, 1);
    },
    fetchData() {
      if (!this.workId) {
        this.onCloseDialog();
        this.$message.error("工单ID不存在");
        return;
      }
      this.fullscreenLoading = true;
      this.$http
        .post(this.url, {
          work_id: this.workId,
        })
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code !== 200) {
            this.onCloseDialog();
            this.$message.error("数据获取失败");
            return;
          }
          const workData = result.data.data.work;
          this.subPorblem = [];
          this.problem = result.data.data.problem;
          this.problem.forEach((item) => {
            if (String(item.problem_id) === String(workData.parent_id)) {
              this.subPorblem = item.children;
            }
          });
          this.model.sub_id = Number(workData.problem_id);
          this.model.id = Number(workData.parent_id);
          this.work = result.data.data.work;
          this.blp_type = result.data.data.blp_type;
          this.dbids = result.data.data.dbids;
          this.form.no_back_num = result.data.data.work.no_back_num;
          this.form.back_remark = result.data.data.work.back_remark;
        })
        .catch((err) => {
          console.error("🚀 : fetchData : err", err.message);
          this.onCloseDialog();
          this.$message.error("数据获取失败");
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
    problemChange(id) {
      this.subPorblem = [];
      this.model.sub_id = 0;
      this.problem.forEach((item) => {
        if (item.problem_id === id) {
          item.children.forEach((v) => {
            this.subPorblem.push(v);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0;
}

.el-form-item label {
  width: 150px !important;
}

.el-form-item__content {
  margin-left: 150px !important;
}

.blp-box {
  display: flex;
  flex-direction: row;
}

.blp-text {
  width: 50px;
}

.blp-input {
  width: 130px;
  margin-right: 10px;
}

.blp-note {
  width: 120px;
}

.blp-op {
  margin-left: 10px;
}

.blp-img-up {
  margin-left: 10px;
  width: 40px;
}

.el-icon-picture {
  font-size: 20px;
}

.header-box {
  width: 100%;
  height: 30px;
  padding: 5px;
  font-size: 15px;
  line-height: 30px;
  background-color: rgb(243, 243, 243);
}

.el-dialog__header,
.el-dialog__body {
  padding-top: 0 !important;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/claims/components/UnPackage.vue